module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Funeral Expenses — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is based on an average from claims of a similar type. Where there is insufficient\n        data within the tool to derive an average a figure of £5,000 is applied.\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-065479e1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/lost/accordian-content/FuneralExpensesModal.vue
// module id = 1560
// module chunks = 0